<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Ganatak Community</h4>
            <button class="btn btn-primary" (click)="addCoupon()">
              Add Ganatak Community
            </button>
          </div>
          <div class="card-body">
            <p class="card-text">Ganatak Community List</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" class="mr-2">show</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span>Entries</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">Search</label>
              <input
                id="searchInput"
                type="search"
                placeholder="search"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable
          [rows]="levels" 
          [rowHeight]="58"
          class="bootstrap core-bootstrap bg-white"
          [limit]="itemsPerPage"
          [columnMode]="ColumnMode.force"
          [headerHeight]="40"
          [footerHeight]="50"
          [scrollbarH]="true"
        >
          <ngx-datatable-column
            name="ID"
            prop="id"
            [width]="20"
          ></ngx-datatable-column>
  
          <ngx-datatable-column
          name="Image"
          [width]="100"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="cell-line-height text-center">
              <img [src]="row.user.image" alt="Ad Image" width="60" height="60" />
            </div>
          </ng-template>
        </ngx-datatable-column>

  
  
          <ngx-datatable-column
          name="Name"
          prop="name"
          [width]="50"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="cell-line-height">
              <p class="font-medium-1 font-weight-bold mb-25">
                {{ row.user.name }}
              </p>
            </div>
          </ng-template>
        </ngx-datatable-column>

          <ngx-datatable-column
          name="Bio"
          prop="bio"
          [width]="50"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="cell-line-height">
              <p class="font-medium-1 font-weight-bold mb-25">
                {{ row.user.bio }}
              </p>
            </div>
          </ng-template>
        </ngx-datatable-column>

          <ngx-datatable-column
          name="Mobile"
          prop="mobile"
          [width]="50"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="cell-line-height">
              <p class="font-medium-1 font-weight-bold mb-25">
                {{ row.user.mobile }}
              </p>
            </div>
          </ng-template>

        </ngx-datatable-column>
  
          <ngx-datatable-column
            name="actions"
            [width]="20"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div ngbDropdown container="body">
                <button
                  type="button"
                  class="btn btn-sm hide-arrow"
                  ngbDropdownToggle
                >
                  <i data-feather="more-vertical"></i>
                </button>
                <div ngbDropdownMenu>
                  <a
                    ngbDropdownItem
                    [routerLink]="['/main/coupons/edit', row.id]"
                  >
                    <i data-feather="edit-2" class="mr-50"></i
                    ><span>{{ "MENU.Edit" | translate }}</span>
                  </a>
                  <a ngbDropdownItem (click)="confirmDelete(row.id)">
                    <i data-feather="trash" class="mr-50"></i
                    ><span>{{ "MENU.Delete" | translate }}</span>
                  </a>
                </div>
              </div> 
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable> 
      </section>
    </div>
  </div>
  